<template>

  <div>
    <div class="card-header">
      <strong>{{ $t('GDPR') }}</strong>
    </div>
    <ul
      class="list-group list-group-flush"
      v-if="showHistory">
      <li
        class="list-group-item list-group-item-warning"
        v-for="(gdprlog, index) in gdprlogs"
        :key="index">
        <strong>{{ getTitle(gdprlog.type) }}</strong>
        <div
          v-if="gdprlog.content"
          class="my-2"
          style="white-space: pre-wrap;">{{ gdprlog.content }}</div>
        <small class="">30 de set. de 2020 por William Coelho</small>
      </li>
    </ul>
    <button
      class="btn btn-light btn-block"
      @click="showHistory=!showHistory"
      style="font-weight: bold;">
        <span v-if="!showHistory">{{ $t('Show history') }}</span>
        <span v-if="showHistory">{{ $t('Hide history') }}</span>
      </button>
  </div>

</template>

<script>
export default {
  name: 'CandidateProfileGDPR',
  components: {
  },
  data () {
    return {
      showHistory: true
    }
  },
  created () {
  },
  computed: {
    gdprlogs () {
      return this.$store.getters.getGdprlogs
    }
  },
  methods: {
    getTitle (type) {
      return {
        'consented': this.$t('Consented'),
        'consent_required': this.$t('Requested consent'),
        'declined': 'Declinou'
      }[type] || type
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .date {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileGDPR.vue